import React from 'react';
import Carousel from '../carousel/carousel';
import { NavLink } from "react-router-dom";
import { urlparams } from "../../config/bootstrap";
import { onClickNavLinkMantra } from "../../utils/helper";



class Mantra6_3 extends React.Component {
    render() {
        return (
            <div>

                <div className="shared_bg">
                    {/* <Carousel /> */}
                    <div className="container">
                        <div className="shared_post">
                            <img src="/assets/img/thank.png" className="img-fluid d-block mx-auto" alt="" />
                            <h5>Email has been sent to<br />
                                <span>{this.props.email}</span>
                            </h5>

                        </div>
                        <div className="preview_btn">
                            <a href="#" onClick={this.props.closeThankYouPopUp}>Okay</a>
                        </div>
                        <div className="home_btn">
                            <NavLink
                                to={"/" + urlparams}
                                onClick={() => onClickNavLinkMantra("", { name: "home" })}
                            >
                                <a href="#">Go to Mantra's Home &#10230;</a>
                            </NavLink>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default Mantra6_3;